import SignUp from './../../components/Auth/SignUp';

function SignupPage() {
    return (
        <SignUp />
    )
}
export default SignupPage;

